import { createFileRoute } from '@tanstack/react-router'
import { ContractPage } from '../../../components/ContractPage'

export const Route = createFileRoute('/$org/contracts/$contractUid')({
  component: ContractDetail,
})

function ContractDetail() {
  return <ContractPage />
}